type Props = {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
};

export default function StatusBlock({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
  secondaryLabel,
  onSecondary,
}: Props) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 rounded-lg border border-dashed border-background-300 bg-background-100/60">
      <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 text-2xl">
        <i className={icon} />
      </div>
      <h3 className="mt-4 text-base font-bold text-foreground-900">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-foreground-500 max-w-[420px] leading-6">{description}</p>
      )}
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {actionLabel}
          </button>
        )}
        {secondaryLabel && onSecondary && (
          <button
            type="button"
            onClick={onSecondary}
            className="h-9 px-4 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {secondaryLabel}
          </button>
        )}
      </div>
    </div>
  );
}